module.exports = __webpack_public_path__ + "static/media/game_cover_penguin.8d24bff8.png";